import { IconType } from 'react-icons/lib';

const VerticalIconButton = ({
  label,
  icon: Icon,
  colorClassName,
  onClick,
}: {
  label: string;
  icon: IconType;
  colorClassName?: string;
  onClick?: () => void;
}) => (
  <button
    className="flex flex-col items-center gap-y-1.5 group cursor-pointer"
    onClick={onClick}
  >
    <span
      className={`rounded-xl p-2 bg-gray-100 group-hover:bg-gray-200 
      ${colorClassName || 'text-red-400 group-hover:text-red-600'}`}
    >
      <Icon size={22} />
    </span>
    <span className="text-3xs text-gray-600 font-light relative group-hover:text-gray-900">
      <span className="absolute top-0 left-1/2 -translate-x-1/2 min-w-max">
        {label}
      </span>
    </span>
  </button>
);

export default VerticalIconButton;
